import useProfile from './useProfile';
import PasswordInput from 'components/PasswordInput';
import styles from './Profile.module.css';

export default function Profile() {
  const {
    form, alert, setAlert, saving, showPwd, otpVerified, otpSent, otpValue, setOtpValue, otpSending,
    otpLoading, otpError, countdown, user, role, isOwner, sendOtp, verifyOtp, handleTogglePwd, set,
    handleSubmit,
  } = useProfile();

  return (
    <div className={styles.contenedor}>
      <div className="page-header">
        <div>
          <h1><i className={`fas fa-user-circle ${styles.iconoCabecera}`} />Mi perfil</h1>
          <p>Gestiona tu información personal</p>
        </div>
      </div>

      {/* Card resumen */}
      <div className={`card ${styles.tarjetaResumen}`}>
        <div className={styles.avatar}>
          <span className={styles.avatarInicial}>
            {user?.name?.[0]?.toUpperCase()}
          </span>
        </div>
        <div className={styles.resumenTexto}>
          <div className={styles.resumenNombre}>
            {user?.name} {user?.last_name}
          </div>
          <div className={styles.resumenCorreo}>{user?.email}</div>
          <span className={styles.chipRol} style={{ '--tono': role.color, '--fondo': role.fondo || role.color + '22' }}>
            {role.text}
          </span>
        </div>
      </div>

      {alert && (
        <div className={`alert alert-${alert.type} ${styles.avisoPerfil}`} onClick={() => setAlert(null)}>
          {alert.message}
        </div>
      )}

      {/* Formulario */}
      <div className={`card ${styles.tarjetaFormulario}`}>
        <h3 className={styles.tituloFormulario}>
          <i className={`fas fa-pen ${styles.iconoTitulo}`} />
          Editar información
        </h3>

        <form onSubmit={handleSubmit} noValidate>
          {/* Datos personales */}
          <div className={styles.rejilla}>
            <div className="form-group">
              <label className={styles.etiqueta}>Nombre *</label>
              <input className="form-control" value={form.name}
                onChange={e => set('name', e.target.value)} maxLength={150} required />
            </div>
            <div className="form-group">
              <label className={styles.etiqueta}>Apellido</label>
              <input className="form-control" value={form.last_name}
                onChange={e => set('last_name', e.target.value)} maxLength={150} />
            </div>
          </div>

          <div className="form-group">
            <label className={styles.etiqueta}>Email</label>
            <input className={`form-control ${styles.campoBloqueado}`}
              value={user?.email} disabled />
            <small className={styles.nota}>
              El correo es tu llave de acceso al sistema y no puede modificarse.
            </small>
          </div>

          <div className="form-group">
            <label className={styles.etiqueta}>Teléfono</label>
            <input className="form-control" value={form.phone}
              onChange={e => set('phone', e.target.value)} placeholder="Ej: 3001234567" inputMode="tel" maxLength={10} />
            <small className={styles.nota}>
              {isOwner
                ? 'Lo usamos para avisarte de las asambleas de tu conjunto. Mantenlo al día.'
                : 'Número de contacto.'}
            </small>
          </div>

          <div className="form-group">
            <label className={styles.etiqueta}>Tipo de usuario</label>
            <input className={`form-control ${styles.campoBloqueado}`}
              value={role.text} disabled />
            <small className={styles.nota}>El tipo de usuario no puede modificarse</small>
          </div>

          {/* Sección contraseña */}
          <div className={styles.bloqueClave}>
            <button type="button" onClick={handleTogglePwd}
              className={showPwd ? styles.botonClaveAbierto : styles.botonClave}>
              <i className={`fas fa-${showPwd ? 'minus' : 'plus'}-circle ${styles.iconoBoton6}`} />
              {showPwd ? 'Cancelar cambio de contraseña' : 'Cambiar contraseña'}
            </button>

            {showPwd && (
              <div>
                {/* Error OTP */}
                {otpError && (
                  <div className={`alert alert-danger ${styles.avisoCodigo}`}>
                    {otpError}
                  </div>
                )}

                {/* Paso OTP — verificar identidad */}
                {!otpVerified && (
                  <div className={styles.cajaCodigo}>
                    <div className={styles.cajaCodigoTitulo}>
                      <i className={`fas fa-shield-halved ${styles.iconoAcento6}`} />
                      Verifica tu identidad para cambiar la contraseña
                    </div>
                    {!otpSent ? (
                      <button type="button" className={`btn btn-secondary btn-sm ${styles.botonEnviar}`}
                        onClick={sendOtp} disabled={otpSending}>
                        {otpSending
                          ? <><div className={`spinner ${styles.spinner14}`} /> Enviando...</>
                          : <><i className={`fas fa-paper-plane ${styles.iconoBoton6}`} />Enviar código a {user?.email}</>}
                      </button>
                    ) : (
                      <div className={styles.filaCodigo}>
                        <div className={`form-group ${styles.grupoCodigo}`}>
                          <label className={styles.etiquetaCodigo}>Código de verificación</label>
                          <input className={`form-control ${styles.campoCodigo}`}
                            value={otpValue}
                            onChange={e => setOtpValue(e.target.value.replace(/\D/g, '').slice(0, 6))}
                            placeholder="000000" maxLength={6}
                            autoFocus />
                        </div>
                        <button type="button" className={`btn btn-primary btn-sm ${styles.botonVerificar}`}
                          onClick={verifyOtp} disabled={otpLoading || otpValue.length !== 6}>
                          {otpLoading
                            ? <div className={`spinner ${styles.spinner14}`} />
                            : <><i className={`fas fa-check ${styles.iconoBoton4}`} />Verificar</>}
                        </button>
                      </div>
                    )}
                    {otpSent && (
                      <div className={styles.reenviar}>
                        {countdown > 0
                          ? `Reenviar en ${countdown}s`
                          : <button type="button" className={styles.botonReenviar}
                              onClick={sendOtp} disabled={otpSending}>
                              <i className={`fas fa-rotate ${styles.iconoBoton4}`} />Reenviar código
                            </button>}
                      </div>
                    )}
                  </div>
                )}

                {/* Formulario de contraseña — solo tras verificar OTP */}
                {otpVerified && (
                  <div>
                    <div className={styles.identidadVerificada}>
                      <i className={`fas fa-check-circle ${styles.iconoBoton4}`} />Identidad verificada
                    </div>
                    <div className="form-group">
                      <label className={styles.etiqueta}>Contraseña actual *</label>
                      <PasswordInput autoComplete="current-password"
                        value={form.current_password} onChange={e => set('current_password', e.target.value)}
                        placeholder="Tu contraseña actual" />
                    </div>
                    <div className={styles.rejilla}>
                      <div className="form-group">
                        <label className={styles.etiqueta}>Nueva contraseña *</label>
                        <PasswordInput autoComplete="new-password"
                          value={form.password} onChange={e => set('password', e.target.value)}
                          placeholder="Mín. 8 caracteres" maxLength={72} />
                      </div>
                      <div className="form-group">
                        <label className={styles.etiqueta}>Confirmar contraseña *</label>
                        <PasswordInput autoComplete="new-password"
                          value={form.confirm_password} onChange={e => set('confirm_password', e.target.value)}
                          placeholder="Repite la contraseña" maxLength={72} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className={styles.acciones}>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving
                ? <><div className={`spinner ${styles.spinner16}`} /> Guardando...</>
                : <><i className="fas fa-save" /> Guardar cambios</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}